import React from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

interface FilmstripOverlayProps {
    images: string[];
    selectedIndex: number;
    onSelect: (index: number) => void;
    onClear: () => void;
}

const FilmstripOverlay: React.FC<FilmstripOverlayProps> = ({
    images,
    selectedIndex,
    onSelect,
    onClear
}) => {
    if (images.length === 0) return null;

    // Scroll to selected effect could be added here with a ref

    return (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-40 bg-black/80 backdrop-blur-md border border-zinc-800 rounded-2xl p-2 flex items-center gap-2 max-w-[90%] shadow-2xl">
            {/* Clear Button (Optional, might want a dedicated close for the whole strip) */}
            <button
                onClick={onClear}
                className="p-1.5 hover:bg-zinc-700/50 rounded-full text-zinc-500 hover:text-red-400 transition-colors mr-2 border-r border-zinc-700/50 pr-3"
                title="Clear Session"
            >
                <X size={14} />
            </button>

            {/* Thumbnails Container */}
            <div
                className="flex items-center gap-2 overflow-x-auto overflow-y-hidden px-1 max-w-[600px]"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .custom-scrollbar::-webkit-scrollbar { display: none; }
                `}} />
                {images.map((img, idx) => (
                    <button
                        key={idx}
                        onClick={() => onSelect(idx)}
                        className={`relative group flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all ${idx === selectedIndex
                            ? 'border-indigo-500 ring-2 ring-indigo-500/20 scale-105'
                            : 'border-zinc-700 hover:border-zinc-500 opacity-70 hover:opacity-100 hover:scale-105'
                            }`}
                    >
                        <img
                            src={img}
                            alt={`Version ${idx + 1}`}
                            className="w-full h-full object-cover"
                        />
                        {/* Number Badge */}
                        <div className="absolute top-0.5 right-0.5 bg-black/60 text-[8px] text-white px-1 rounded-bl">
                            {idx + 1}
                        </div>
                    </button>
                ))}
            </div>

            <div className="text-xs text-zinc-500 font-medium px-2 border-l border-zinc-700/50 ml-2">
                {selectedIndex + 1} / {images.length}
            </div>
        </div>
    );
};

export default FilmstripOverlay;
